import React, { Component } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Configurar el icono por defecto de Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

class ArcGISMap extends Component {
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.map = null;
    this.polyline = null;
    this.markers = [];
  }

  componentDidMount() {
    this.initializeMap();
    this.updateMap();
  }

  componentDidUpdate(prevProps) {
    // if (prevProps.trackPoints !== this.props.trackPoints) {
    //   this.updateMap();
    // }
  }

  componentWillUnmount() {
    if (this.map) {
      this.map.remove();
    }
  }

  initializeMap() {
    const { trackPoints } = this.props;
    
    // Calcular el centro del mapa basado en los trackPoints
    let centerLat = 19.4326; // Default Ciudad de México
    let centerLng = -99.1332;
    let zoom = 6;

    if (trackPoints && trackPoints.length > 0) {
      const validPoints = trackPoints.filter(point => 
        point.position && 
        point.position.latitude && 
        point.position.longitude
      );

      if (validPoints.length > 0) {
        centerLat = validPoints.reduce((sum, point) => sum + point.position.latitude, 0) / validPoints.length;
        centerLng = validPoints.reduce((sum, point) => sum + point.position.longitude, 0) / validPoints.length;
        zoom = 10; // Zoom más cercano cuando hay puntos
      }
    }

    // Crear el mapa
    this.map = L.map(this.mapRef.current, {
      center: [centerLat, centerLng],
      zoom: zoom,
      scrollWheelZoom: false
    });

    // Añadir la capa de ArcGIS
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
      attribution: 'Powered by Esri',
      maxZoom: 19
    }).addTo(this.map);
  }

  updateMap() {
    if (!this.map || !this.props.trackPoints) return;

    // Limpiar marcadores y líneas anteriores
    this.clearMap();

    const { trackPoints } = this.props;
    
    // Filtrar puntos válidos
    const validPoints = trackPoints.filter(point => 
      point.position && 
      point.position.latitude && 
      point.position.longitude &&
      !isNaN(point.position.latitude) &&
      !isNaN(point.position.longitude)
    );

    if (validPoints.length === 0) return;

    // Extraer coordenadas para la polilínea
    const coordinates = validPoints.map(point => [
      point.position.latitude,
      point.position.longitude
    ]);

    // Crear y añadir la polilínea (ruta)
    this.polyline = L.polyline(coordinates, {
      color: '#0066CC',
      weight: 4,
      opacity: 0.8,
      smoothFactor: 1
    }).addTo(this.map);

    // Añadir marcadores para puntos importantes
    if (validPoints.length > 0) {
      // Marcador de inicio (verde)
      //  const startPoint = validPoints[0];
      //  const startMarker = L.marker([startPoint.position.latitude, startPoint.position.longitude], {
      //    icon: L.divIcon({
      //      html: '<div style="background-color: #28a745; width: 20px; height: 20px; border-radius: 50%; border: 3px solid white; box-shadow: 0 0 4px rgba(0,0,0,0.4);"></div>',
      //      iconSize: [20, 20],
      //      className: 'custom-div-icon'
      //    })
      //  }).addTo(this.map);
      
      // startMarker.bindPopup(`
      //   <b>Punto de Inicio</b><br>
      //   Hora: ${new Date(startPoint.utc).toLocaleString()}<br>
      //   Lat: ${startPoint.position.latitude.toFixed(6)}<br>
      //   Lng: ${startPoint.position.longitude.toFixed(6)}<br>
      //   ${startPoint.velocity ? `Velocidad: ${(startPoint.velocity.groundSpeed * 3.6).toFixed(1)} km/h` : ''}
      // `);
      // this.markers.push(startMarker);

      // Marcador de fin (rojo)
      // if (validPoints.length > 1) {
      //   const endPoint = validPoints[validPoints.length - 1];
      //   const endMarker = L.marker([endPoint.position.latitude, endPoint.position.longitude], {
      //     icon: L.divIcon({
      //       html: '<div style="background-color: #dc3545; width: 20px; height: 20px; border-radius: 50%; border: 3px solid white; box-shadow: 0 0 4px rgba(0,0,0,0.4);"></div>',
      //       iconSize: [20, 20],
      //       className: 'custom-div-icon'
      //     })
      //   }).addTo(this.map);
        
      //   endMarker.bindPopup(`
      //     <b>Punto Final</b><br>
      //     Hora: ${new Date(endPoint.utc).toLocaleString()}<br>
      //     Lat: ${endPoint.position.latitude.toFixed(6)}<br>
      //     Lng: ${endPoint.position.longitude.toFixed(6)}<br>
      //     ${endPoint.velocity ? `Velocidad: ${(endPoint.velocity.groundSpeed * 3.6).toFixed(1)} km/h` : ''}
      //   `);
      //   this.markers.push(endMarker);
      // }

      // Añadir marcadores para detenciones (velocidad muy baja)
     // const detenciones = this.detectarDetenciones(validPoints);
      // detenciones.forEach((detencion, index) => {
      //   const marker = L.marker([detencion.latitude, detencion.longitude], {
      //     icon: L.divIcon({
      //       html: '<div style="background-color: #ffc107; width: 15px; height: 15px; border-radius: 50%; border: 2px solid white; box-shadow: 0 0 4px rgba(0,0,0,0.4);"></div>',
      //       iconSize: [15, 15],
      //       className: 'custom-div-icon'
      //     })
      //   }).addTo(this.map);
        
      //   marker.bindPopup(`
      //     <b>Detención ${index + 1}</b><br>
      //     Duración: ${detencion.duracion} min<br>
      //     Hora inicio: ${detencion.horaInicio}<br>
      //     Hora fin: ${detencion.horaFin}
      //   `);
      //   this.markers.push(marker);
      // });
    }

    // Ajustar el mapa para mostrar toda la ruta
    if (coordinates.length > 0) {
      const bounds = L.latLngBounds(coordinates);
      this.map.fitBounds(bounds, { padding: [50, 50] });
    }
  }

  // detectarDetenciones(validPoints) {
  //   const detenciones = [];
  //   const UMBRAL_VELOCIDAD = 0.5; // m/s (1.8 km/h)
  //   const TIEMPO_MINIMO_DETENCION = 15; // minutos
    
  //   let inicioDetencion = null;
  //   let puntosPorMinuto = this.calcularPuntosPorMinuto(validPoints);

  //   for (let i = 0; i < validPoints.length; i++) {
  //     const punto = validPoints[i];
  //     const velocidad = punto.velocity ? punto.velocity.groundSpeed : 0;
      
  //     if (velocidad < UMBRAL_VELOCIDAD) {
  //       if (!inicioDetencion) {
  //         inicioDetencion = {
  //           index: i,
  //           punto: punto,
  //           tiempo: new Date(punto.utc)
  //         };
  //       }
  //     } else if (inicioDetencion) {
  //       const tiempoDetencion = (new Date(punto.utc) - inicioDetencion.tiempo) / (1000 * 60); // minutos
        
  //       if (tiempoDetencion >= TIEMPO_MINIMO_DETENCION) {
  //         detenciones.push({
  //           latitude: inicioDetencion.punto.position.latitude,
  //           longitude: inicioDetencion.punto.position.longitude,
  //           duracion: Math.round(tiempoDetencion),
  //           horaInicio: inicioDetencion.tiempo.toLocaleTimeString(),
  //           horaFin: new Date(validPoints[i-1].utc).toLocaleTimeString()
  //         });
  //       }
  //       inicioDetencion = null;
  //     }
  //   }

  //   // Verificar si hay una detención al final
  //   if (inicioDetencion && validPoints.length > 0) {
  //     const ultimoPunto = validPoints[validPoints.length - 1];
  //     const tiempoDetencion = (new Date(ultimoPunto.utc) - inicioDetencion.tiempo) / (1000 * 60);
      
  //     if (tiempoDetencion >= TIEMPO_MINIMO_DETENCION) {
  //       detenciones.push({
  //         latitude: inicioDetencion.punto.position.latitude,
  //         longitude: inicioDetencion.punto.position.longitude,
  //         duracion: Math.round(tiempoDetencion),
  //         horaInicio: inicioDetencion.tiempo.toLocaleTimeString(),
  //         horaFin: new Date(ultimoPunto.utc).toLocaleTimeString()
  //       });
  //     }
  //   }

  //   return detenciones;
  // }

  calcularPuntosPorMinuto(validPoints) {
    if (validPoints.length < 2) return 1;
    
    const primerPunto = new Date(validPoints[0].utc);
    const ultimoPunto = new Date(validPoints[validPoints.length - 1].utc);
    const duracionMinutos = (ultimoPunto - primerPunto) / (1000 * 60);
    
    return duracionMinutos > 0 ? validPoints.length / duracionMinutos : 1;
  }

  clearMap() {
    // Eliminar polilínea
    if (this.polyline) {
      this.map.removeLayer(this.polyline);
      this.polyline = null;
    }

    // Eliminar marcadores
    this.markers.forEach(marker => {
      this.map.removeLayer(marker);
    });
    this.markers = [];
  }

  render() {
    return (
      <div 
        ref={this.mapRef} 
        style={{ 
          width: '100%', 
          height: '100%',
          minHeight: '400px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
      />
    );
  }
}

export default ArcGISMap;